import React from 'react';
import { useAsync } from 'react-async-hook';
import { useLocationQueryState } from '../Common/useLocationQueryState';
import { usePluginDataProviderContext } from '../PluginDataProvider/PluginDataProviderContext';
import { useRequestListContext } from '../RequestListView/RequestListContext';
import { RequestListTaskDto } from '../types';

export const TaskQueryParamName = 'task';

export function useViewedItem(items: RequestListTaskDto[] | undefined) {
	const dataProvider = usePluginDataProviderContext();
	const { requestList } = useRequestListContext();
	const [taskIdFromRoute, setTaskIdInRoute] = useLocationQueryState(TaskQueryParamName);
	const [viewedItem, viewItem] = React.useState<RequestListTaskDto>();

	useAsync(
		async () => {
			if (!taskIdFromRoute) {
				viewItem(undefined);
				return;
			}

			const pagedItem = items?.find(i => i.requestListTaskId === taskIdFromRoute);
			const result =
				pagedItem ??
				(await dataProvider
					.getTask(requestList.requestListId, requestList.resourceId, taskIdFromRoute)
					.catch(() => undefined));
			viewItem(result);
		},
		[taskIdFromRoute],
		{
			executeOnMount: !!taskIdFromRoute,
		}
	);

	return {
		viewedItem,
		viewItemById(itemId?: string, options?: { clearExtraParams?: string[] }) {
			if (itemId !== taskIdFromRoute) {
				setTaskIdInRoute(itemId, options);
			}
		},
		updateViewedItem: (item: RequestListTaskDto) =>
			viewItem(currentItem => {
				if (currentItem && currentItem.requestListTaskId === item.requestListTaskId) {
					return item;
				}
				return currentItem;
			}),
	};
}
